import { render, staticRenderFns } from "./userNeedList.vue?vue&type=template&id=24afa901&"
import script from "./userNeedList.vue?vue&type=script&lang=js&"
export * from "./userNeedList.vue?vue&type=script&lang=js&"
import style0 from "./userNeedList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports